/**
 * @ComponentFor Avensia.Shop.Features.Cms.Blocks.ShortcutButtonsBlock.ShortcutButtonsBlockViewModel
 */
import React from "react";
import classnames from "classnames";
import * as styles from "./base.scss";
import ShortcutButtonBlock from "../ShortcutButtonBlock/ShortcutButtonBlock";
const ShortcutButtonsBlock = (props) => {
    var _a, _b, _c;
    return (React.createElement("div", { className: classnames(styles.baseLevel, styles.blockBckground, !!props.backgroundColor &&
            styles[(_a = props.backgroundColor) === null || _a === void 0 ? void 0 : _a.toLowerCase()]), "data-opti-id": "component-shortcut-button" },
        React.createElement("div", { className: classnames(styles.shortcutButtonsBlock, !!props.passedStyles && props.passedStyles.shortcutButtonsContainer, styles.blockPadding, !!props.padding &&
                styles[(_b = props.padding) === null || _b === void 0 ? void 0 : _b.toLowerCase()]) },
            props.header &&
                (((_c = props.headerLevel) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === "h3" ? (React.createElement("h3", null, props.header)) : (React.createElement("h2", null, props.header))),
            React.createElement("div", { className: classnames(styles.container) }, props.buttons.map((button, index) => (React.createElement(ShortcutButtonBlock, { key: !!props.tabIndex ? props.tabIndex + index : index, model: button, tabIndex: props.tabIndex })))))));
};
export default ShortcutButtonsBlock;
